export default __webpack_public_path__ + "static/media/kd.8e3270a2.png";